// frontend/src/themes/palettes/sakura.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#EBB7CC",
  palette: {
    primary:    { main: "#EC6A9F" },
    secondary:  { main: "#BA68C8" },
    background: { default: "#FFF4F7", paper: "#FFFFFF" },
    text:       { primary: "#5A2A3E", secondary: "#8A5A6E" },
    divider:    "#F4D9E3",
    action:     { hover: "rgba(236,106,159,0.05)", selected: "rgba(236,106,159,0.09)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFFFF" },
        notchedOutline: { borderColor: "#EBC0D2" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#FBE2EB", quotedSentBg: "#F6D0DF", quotedReceivedBg: "#FBF0F4", accent: "#EC6A9F", contactAccent: "#BA68C8" },
    chartPalette: ["#EC6A9F", "#BA68C8", "#F48FB1", "#FFB74D", "#81C784", "#9575CD"],
    login: { bg: "#FFF4F7" },
  },
};
